import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import { fetchCurrentTournament } from '../../../api/tournament';

const TournamentTimer = ({ date }) => {
    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        if (!date) return;

        const tick = () => {
            const endTime = new Date(date + 'T05:00:00Z');
            endTime.setUTCDate(endTime.getUTCDate() + 1);
            const diff = endTime.getTime() - Date.now();
            if (diff <= 0) {
                setTimeLeft('Finalizing...');
                return;
            }
            const hrs = Math.floor(diff / 3_600_000);
            const mins = Math.floor((diff % 3_600_000) / 60_000);
            setTimeLeft(`${hrs}h ${String(mins).padStart(2, '0')}m remaining`);
        };

        tick();
        const interval = setInterval(tick, 60_000);
        return () => clearInterval(interval);
    }, [date]);

    if (!timeLeft) return null;
    return <span className="dash-tournament-timer">{timeLeft}</span>;
};

const TournamentCard = () => {
    const { data, loading } = useFetch(fetchCurrentTournament, null);

    if (loading || !data?.tournament) return null; // no tournament running today

    const { tournament, userEntry, leaderboard = [] } = data;
    const userRank = userEntry
        ? leaderboard.findIndex(e => String(e.tournamentEntryID) === String(userEntry.tournamentEntryID)) + 1
        : 0;
    const totalEntries = leaderboard.length;

    if (!userEntry) {
        return (
            <div className="priority-card accent-purple">
                <div className="action-row">
                    <div>
                        <h3
                            style={{
                                fontFamily: "'New Amsterdam', sans-serif",
                                fontSize: '1.3rem',
                                letterSpacing: '1px',
                                color: '#212529',
                                margin: 0,
                            }}
                        >
                            {tournament.name}
                        </h3>
                        <div className="action-detail">
                            Tournament in progress — join now!
                            {tournament.date ? (
                                <>
                                    {' '}
                                    · <TournamentTimer date={tournament.date} />
                                </>
                            ) : null}
                        </div>
                    </div>
                    <Link to="/tournament" className="card-cta purple">
                        Join Tournament
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="priority-card accent-purple">
            <div className="priority-card-header">
                <h3>{tournament.name}</h3>
                <Link to="/tournament">View Bracket</Link>
            </div>
            <div className="action-row">
                <div>
                    <div style={{ fontSize: '0.95rem' }}>
                        Your record:{' '}
                        <strong>
                            {userEntry.wins}-{userEntry.losses}
                        </strong>
                        {userRank > 0 && (
                            <>
                                {' '}
                                · Ranked <strong>#{userRank}</strong> of {totalEntries}
                            </>
                        )}
                        {tournament.date ? (
                            <div className="action-detail">
                                <TournamentTimer date={tournament.date} />
                            </div>
                        ) : null}
                    </div>
                    <div style={{ fontSize: '0.95rem' }}>
                        Play 5 games to get a silver pack, play 10 games to get a GOLD pack.
                    </div>
                </div>
                <Link to="/tournament" className="card-cta secondary">
                    Play
                </Link>
            </div>
        </div>
    );
};

export default TournamentCard;
